<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <vm-table ref="vmTable" module="basic" :url="'taskDispatchBills?productionPlanId=' + selectpkid" :is-height="false">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.workOrderIssuedEdit.open(0)"> 新建 </el-button>
        </div>
        <el-table-column prop="billNo" align="center" label="派工单号" width="120"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称" min-width="380"/>
        <el-table-column prop="statusName" align="center" label="工单状态" width="80"/>
        <el-table-column prop="feedingStatusName" align="center" label="发料状态" width="80"/>
        <el-table-column prop="routingName" align="left" label="工艺路线" min-width="120"/>
        <el-table-column prop="quantity" align="center" label="派工数量" width="80"/>
        <el-table-column prop="workCenterName" align="left" label="工作中心" min-width="120"/>
        <el-table-column prop="planStartTime" align="center" label="开工时间" width="150"/>
        <el-table-column prop="planFinishTime" align="center" label="完工时间" width="150"/>
        <el-table-column
            label="操作"
            align="center"
            width="160px"
            fixed="right"
            prop="action">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.status !== 10" type="primary" @click="$refs.workOrderIssuedEdit.open(scope.row.pkid)"> 编辑 </el-button>
            <el-button type="success" @click="$refs.workOrderIssuedEdit.open(scope.row.pkid, true)">详情</el-button>
            <el-button :disabled="scope.row.status !== 10" type="danger" @click="deleteRow(scope.row.pkid)"> 删除 </el-button>
          </template>
        </el-table-column>
      </vm-table>

      <!--派工单信息模态框 -->
      <work-order-issued-edit ref="workOrderIssuedEdit" :product-order-info="orderInfo" @save-success="saveSuccess"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import WorkOrderIssuedEdit from "./WorkOrderIssuedEdit.vue";
  export default {
    name: "BatchInfo",
    components: { VmTable, WorkOrderIssuedEdit },
    props: {
      pkid: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        selectpkid: 0, // 选中的生产订单pkid
        orderInfo: null,
      };
    },

    watch: {
      pkid: {
        immediate: true,
        handler(val) {
          this.selectpkid = val;
          this.getOrderInfoById(val);
        },
      },
    },

    methods: {
      // 查询派工单信息
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      // 单个删除
      deleteRow(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "taskDispatchBills", pkid).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
            }
          });
        });
      },

      // 根据pkid查询订单计划详细信息
      getOrderInfoById() {
        this.$http.get("basic", `productionOrders/${this.selectpkid}`).then((resp) => {
          if (resp.success) {
            this.orderInfo = resp.data;
            this.getList(1);
          }
        });
      },

      saveSuccess() {
        this.getList(1);
        this.$emit("save-success");
      },
    },
  };
</script>
